<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-notification`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M29 40a1 1 0 011 1v2a1 1 0 01-1 1H19a1 1 0 01-1-1v-2a1 1 0 011-1h10zM27 3a1 1 0 011 1v1.52c6.901 1.834 12 8.3 12 15.996V33h3a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h3V21.516C8 13.82 13.1 7.354 20 5.52V4a1 1 0 011-1h6zm-3 6c-6.627 0-12 5.606-12 12.522V33h24V21.522C36 14.606 30.627 9 24 9z"/></svg>
</template>
<script>

export default {
  name: 'IconNotification',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
